<template>
  <div>
    <div class="sse_footer">
      <div class="ft1 mobile_hide">
        <div class="foot_container">
          <div class="foot_links">
            <p style="color: #656868;font-size: 18px">公司地址：包头市高新开发区黄河大街98号金融广场A座401</p>
            <p style="color: #656868;font-size: 18px;border-left: solid 1px #777;">服务热线：400-999-3589</p>
            <p style="color: #656868;font-size: 18px;border-left: solid 1px #777;">服务邮箱：service@repe.com.cn</p>
          </div>
        </div>
      </div>
      <div class="ft2">
        <div class="foot_container2">
          <div class="ft2_rows clearfix sub_footertext">
            <div class="friend_links fl mobile_hide">
              <p class="links" style="color: #b3b3b3;position: relative;top: 2px;">版权所有：包头稀土产品交易所有限公司</p>
              <a href="https://beian.miit.gov.cn">
                <p class="links" style="color: #b3b3b3;border-left: solid 1px #777;padding: 0 10px;position: relative;top: 2px;">
                  备案号：蒙ICP备16003247号-1
                </p>
              </a>
              <div  class="beian">
                <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=15029002000114">
                </a>
              </div>
              <p class="links"
                 style="color: #b3b3b3;border-left: solid 1px #777;padding: 0 10px;position: relative;top: 2px;"> 蒙公安网备：15029002000114号</p>
              <div  class="liangzhao">
                <a href="https://zzlz.gsxt.gov.cn/businessCheck/verifKey.do?showType=p&serial=911502000578014820-SAIC_SHOW_1000009115020005780148201658131883646&signData=MEYCIQDk/M8atxMoEhwbMqvWhguP0M6MWVOGa6TTSEB0xsG23QIhAJLKC/Dz8ZAt82lxvFyvStOP+md9Ro6KysZygHrl66k+">
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Vfooter"
}
</script>

<style scoped>
@import "../assets/css/footer.css";

</style>



// WEBPACK FOOTER //
// src/components/footer.vue